import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import BordonaApp from './App';
import { TRPCProvider } from './providers/trpc';
import './index.css';

const root = ReactDOM.createRoot(document.getElementById('root')!);

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <TRPCProvider>
        <BordonaApp />
      </TRPCProvider>
    </BrowserRouter>
  </React.StrictMode>
);
